"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { PRODUCTS_BINDING } from "@/libs/builder/consts";
import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

import { headerInputs } from "./inputs/headerInputs.builder";

export const HeaderComponent: RegisteredComponent = {
  name: "Header",
  component: withValidation(
    headerInputs,
    dynamic(() => import("./Header").then((mod) => mod.Header)),
    "Header"
  ),
  models: [getBuilderModelName("header")],
  inputs: headerInputs,
  defaults: {
    bindings: PRODUCTS_BINDING,
  },
};
